import styled from 'styled-components';

import { Spinner } from 'components/ui';
import { Theme } from 'utils/color/horizonTheme';

interface StyledCommentsProps {
  $columnLayout?: boolean;
  $isAtTop?: boolean;
  $maxHeight?: string;
}

export const CommentInner = styled.div`
  display: flex;
  padding: 0.5rem 0;
`;

export const CommentAvatar = styled.div`
  position: relative;
  flex-shrink: 0;
  margin-right: 12px;
  cursor: pointer;
`;

export const CommentBody = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-width: 1px;
  font-size: 14px;
  word-wrap: break-word;
`;

export const CommentAuthor = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 4px;

  > span {
    padding-right: 8px;
    font-size: 12px;
    line-height: 18px;
  }
`;

export const CommentAuthorName = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
  color: ${({ theme }) => theme.secondaryTextColor};

  .comment-author-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => (theme.themeName === Theme.Dark ? theme.labelColor : 'unset')};
  }

  .ant-tag {
    flex-shrink: 0;
    margin: 0;
  }
`;

export const CommentAuthorTime = styled.span`
  color: ${({ theme }) => theme.disabledTextColor};
  white-space: nowrap;
`;

export const CommentDetail = styled.div`
  white-space: break-spaces;
  color: ${({ theme }) => (theme.themeName === Theme.Dark ? theme.textColor : 'unset')};
`;

export const CommentActions = styled.ul`
  margin: 0.5rem 0 0 0;
  padding-left: 0;

  > li {
    display: inline-block;
    color: ${({ theme }) => theme.secondaryTextColor};
  }
`;

export const StyledCommentsWrapper = styled.div<StyledCommentsProps>`
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  display: ${({ $columnLayout }) => $columnLayout && 'flex'};

  // to fix the styling in Firefox as a result of the white-space property
  .ant-row::before,
  .ant-row::after,
  .ant-legacy-form-item-control::before,
  .ant-legacy-form-item-control::after {
    display: unset;
    content: unset;
  }

  ${({ $isAtTop, theme }) =>
    !$isAtTop &&
    `
    &:before {
      content: '';
      position: absolute;
      top: -10px;
      left: 0;
      right: 0;
      height: 10px;
      box-shadow: 0px 5px 5px -3px ${theme.lightShadow};
      z-index: 1;
    }
  `}

  ${({ $maxHeight }) =>
    $maxHeight &&
    `
      [data-testid='comments'] {
        overflow-y: auto;
        max-height: ${$maxHeight};
      }

      ${CommentInner} {
        padding-bottom: 0;
      }

      ${CommentDetail} {
        .ant-form-item:nth-child(2) {
          margin-bottom: 0;
        }
      }
  `}
`;

export const StyledSpinner = styled(Spinner)`
  min-height: unset;
`;
